export default "__VITE_ASSET__B945qaAX__"